'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IpcBroadcastChannel = function (_EventEmitter) {
    (0, _inherits3.default)(IpcBroadcastChannel, _EventEmitter);

    function IpcBroadcastChannel() {
        (0, _classCallCheck3.default)(this, IpcBroadcastChannel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IpcBroadcastChannel.__proto__ || (0, _getPrototypeOf2.default)(IpcBroadcastChannel)).call(this));

        _this.bc = new BroadcastChannel('kiwi-ipc');
        _this.bc.onmessage = _this.onmessage.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(IpcBroadcastChannel, [{
        key: 'send',
        value: function send(msg) {
            if (this.bc) {
                this.bc.postMessage(msg);
            }
        }
    }, {
        key: 'onmessage',
        value: function onmessage(msg) {
            this.emit('message', msg);
        }
    }]);
    return IpcBroadcastChannel;
}(_eventemitter2.default);

var IpcLocalStorage = function (_EventEmitter2) {
    (0, _inherits3.default)(IpcLocalStorage, _EventEmitter2);

    function IpcLocalStorage() {
        (0, _classCallCheck3.default)(this, IpcLocalStorage);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (IpcLocalStorage.__proto__ || (0, _getPrototypeOf2.default)(IpcLocalStorage)).call(this));

        window.addEventListener('storage', _this2.onmessage.bind(_this2));
        return _this2;
    }

    (0, _createClass3.default)(IpcLocalStorage, [{
        key: 'send',
        value: function send(msg) {
            localStorage.setItem('kiwi-ipc', (0, _stringify2.default)(msg));
            localStorage.removeItem('kiwi-ipc');
        }
    }, {
        key: 'onmessage',
        value: function onmessage(msg) {
            if (msg.key === 'kiwi-ipc' && msg.newValue) {
                try {
                    var parsedMsg = {
                        data: JSON.parse(msg.newValue)
                    };
                    this.emit('message', parsedMsg);
                } catch (e) {
                    this.emit('error');
                }
            }
        }
    }]);
    return IpcLocalStorage;
}(_eventemitter2.default);

exports.default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/IPC.js
// module id = Y+EK
// module chunks = 1